import {
  ADD_CONTACT,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAILED,
  FETCH_CONTACT,
  FETCH_CONTACT_SUCCESS,
  FETCH_CONTACT_FAILED,
  ADD_JM_USER,
ADD_JM_USER_SUCCESS,
ADD_JM_USER_FAILED,
FETCH_JM_USER ,
FETCH_JM_USER_SUCCESS ,
FETCH_JM_USER_FAILED,
} from "../store/types";
const INITIAL_STATE = {
  contact: null,
  loading: false,
  error: {
    flag: false,
    msg: null,
  },
};

export const contactreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case ADD_CONTACT_SUCCESS:
      return {
        ...state,
        contact: action.payload,
        loading: false,
      };
    case ADD_CONTACT_FAILED: {
      return INITIAL_STATE;
    }

    case FETCH_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CONTACT_SUCCESS:
      return {
        ...state,
        contact: action.payload,
        loading: false,
      };
    case FETCH_CONTACT_FAILED: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};

export const jmuserreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case ADD_CONTACT_SUCCESS:
      return {
        ...state,
        jmuser: action.payload,
        loading: false,
      };
    case ADD_CONTACT_FAILED: {
      return INITIAL_STATE;
    }

    case FETCH_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CONTACT_SUCCESS:
      return {
        ...state,
        jmuser: action.payload,
        loading: false,
      };
    case FETCH_CONTACT_FAILED: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};
